import { deleteBooth, editBooth, createBooth } from "../../api/booth/modal.js";
import { Delete } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Modal, TextInput, UploadImage } from "../../../../shared/ui/common/index.js";

import Confirm from "../../../../shared/ui/modals/Confirm.jsx";


import { logout } from "../../../../shared/state/slices/user.js";
const BoothModal = ({
  open,
  close,
  data = {},
  forEdit,
  setAllRows,
  allRows,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const [selectedProductImage, setselectedProductImage] = useState();
  const { userPermissions } = useSelector((state) => state.relationals);

  const [loading, setLoading] = useState(false);
  const [prevData, setPrevData] = useState({});
  const [openDelete, setOpenDelete] = useState(false);

  // set data
  useEffect(() => {
    if (forEdit) {
      setPrevData({
        ...data,
        parentId: allRows.find((cat) => cat.id === data.parentId),
      });
    } else {
      resetData();
    }
  }, [allRows, data, forEdit]);
  const resetData = () => {
    setPrevData(data);
  };
  const deleteCategory = () => {
    if (data) {
      setLoading(true);
      deleteBooth(data, token)
        .then((res) => {
          setLoading(false);
          setOpenDelete(false);
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };

  const editItem = () => {
    const formData = new FormData();

    formData.append("title", prevData?.title);
    formData.append("description", prevData?.description);
    if (prevData?.avatar) formData.append("files", prevData?.avatar);
    if (selectedProductImage)
      formData.append("fromGallery", selectedProductImage);
    formData.append("webSite", prevData?.webSite);
    if (forEdit) {
      formData.append("id", prevData?.id);
    }
    var temp = [...allRows];
    if (prevData?.title) {
      setLoading(true);
      if (forEdit) {
        editBooth(formData, token)
          .then((res) => {
            setLoading(false);
            toast.success("با موفقیت ویرایش شد");
            var index = temp.findIndex((item) => item.id === data.id);
            temp[index] = res.data.data;
            setAllRows(temp);
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      } else {
        createBooth(formData, token)
          .then((res) => {
            temp.unshift(res.data.data);

            setAllRows(temp);
            setLoading(false);
            toast.success("با موفقیت اضافه شد");
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      }
    } else if (!prevData?.title) {
      toast.error("نام غرفه را وارد کنید");
    }
  };

  return (
    <Modal
      open={open}
      close={close}
      title={` ${forEdit ? "ویرایش" : "افزودن"}  غرفه ها
    `}
    >
      <TextInput
        label="نام غرفه جدید"
        change={(e) => setPrevData({ ...prevData, title: e })}
        currentValue={prevData?.title}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Typography variant="caption">توضیحات</Typography>
        <TextField
          multiline
          value={prevData?.description ?? ""}
          onChange={(e) =>
            setPrevData({ ...prevData, description: e.target.value })
          }
          sx={{ width: "100%" }}
          rows={2}
        />
      </Box>{" "}
      <div className="leftInput">
        <TextInput
          label="  website"
          change={(e) => setPrevData({ ...prevData, webSite: e })}
          currentValue={prevData?.webSite}
        />
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <UploadImage
          file={prevData?.avatar}
          change={(e) => setPrevData({ ...prevData, avatar: e })}
          address={data.galleryId ? data.galleryId : false}
          selectedProductImage={selectedProductImage}
          setselectedProductImage={setselectedProductImage}
        />
      </div>
      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={editItem}
          disabled={loading}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این غرفه اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteCategory}
        open={openDelete}
      />
    </Modal>
  );
};

export default BoothModal;
